
    import { defineComponent } from 'vue';
    import { LoadingState } from '../../../helpers';
    import RowTemplate from './table-row.vue';
    import UserAddTemplate from './user-add.vue';
    import axios from 'axios';

    type AccountUsers = {
        userId: string,
        gravatarUrl: string,
        email: string,
        role: string
    }[];

    interface Data {
        loadingState: LoadingState,
        errored: boolean,
        errorMessage: null | string,
        accountUsers: null | AccountUsers,
        currentUserId?: string
    }

    export default defineComponent({
        components: {
            'table-row': RowTemplate,
            'user-add': UserAddTemplate
        },
        data(): Data {
            return {
                loadingState: LoadingState.Loading,
                errored: false,
                errorMessage: null,
                accountUsers: null,
                currentUserId: undefined
            };
        },
        created() {
            this.currentUserId = this.$auth?.userId;
            this.fetchData();
            this.emitter.on('account-changed', () => this.fetchData());
        },
        computed: {
            isLoaded(): boolean {
                return this.loadingState == LoadingState.Loaded;
            },
            isErrored(): boolean {
                return this.loadingState == LoadingState.Errored;
            }
        },
        methods: {
            fetchData(): void {
                this.accountUsers = null;
                this.loadingState = LoadingState.Loading;

                axios

                    .get('/account/users')
                    .then(response => {
                        this.accountUsers = response.data as AccountUsers
                        this.loadingState = LoadingState.Loaded;
                    })
                    .catch(error => {
                        this.loadingState = LoadingState.Errored;
                        this.errorMessage = error.message;
                        console.log(error);
                    })
            }
        },
    });
